import React from 'react';

function Square({ value, onClick, isWinningSquare }) {
  return (
    <button
      onClick={onClick}
      className={` square ${isWinningSquare ? 'winning' : ''} ${
        value === 'X' ? 'text-green' : 'text-orange'
      }`}
    >
      {value}
    </button>
  );
}

export default Square;
